
export default [
  {
    name: "AGORA",
    tags: ["AI", "law", "policy", "governance"],
    url: "https://agora.eto.tech",
    documentationUrl: "/tool-docs/agora",
    lastUpdated: "2024-06-28",
    description: "A living collection of AI-relevant laws, regulations, standards, and other governance documents from the U.S. and around the world.",
    homepage: true,
  },
  {
    name: "Country Activity Tracker",
    tags: ["AI", "research", "patenting", "investment"],
    url: "https://cat.eto.tech",
    documentationUrl: "/tool-docs/cat",
    lastUpdated: "2025-10-16",
    description: "Track global research, patenting, and investment in AI and its applications with our user-friendly dashboard.",
    homepage: true,
  },
  {
    name: "Chinese Technical Glossary",
    tags: ["China", "translation"],
    url: "https://glossary.eto.tech",
    documentationUrl: "/tool-docs/glossary",
    lastUpdated: "2022-12-04",
    description: "Expert English translations and annotations for over 15,000 specialized terms in Chinese science and tech sources.",
    homepage: false,
  },
  {
    name: "Map of Patents",
    tags: ["research", "patenting"],
    url: "https://patentmap.eto.tech",
    documentationUrl: "/tool-docs/mop",
    lastUpdated: "2026-07-28",
    description: "Explore global intellectual property data, easily pinpointing key trends, hotspots, and players in the innovation landscape.",
    homepage: true,
  },
  {
    name: "Map of Science",
    tags: ["research"],
    url: "https://sciencemap.eto.tech",
    documentationUrl: "/tool-docs/mos",
    lastUpdated: "2026-04-27",
    description: "Explore our mapping of the world’s research literature to reveal key trends, hotspots, and concepts in global science and technology.",
    homepage: true,
  },
  {
    name: "PATHWISE",
    tags: ["AI", "cybersecurity", "workforce"],
    url: "https://pathwise.eto.tech",
    documentationUrl: "/tool-docs/pathwise",
    lastUpdated: "2025-10-30",
    description: "Track the latest workforce and education metrics for emerging technology talent across U.S. regions.",
    homepage: true,
  },
  {
    name: "Research Almanac",
    tags: ["AI", "research"],
    url: "https://almanac.eto.tech",
    documentationUrl: "/tool-docs/almanac",
    lastUpdated: "2025-10-16",
    description: "Review high-level trends in global emerging technology research area, with a focus on topics in AI, biology, cybersecurity, and semiconductors.",
    homepage: true,
  },
  {
    name: "Scout",
    tags: ["China"],
    url: "https://scout.eto.tech",
    documentationUrl: "/tool-docs/scout",
    lastUpdated: "2023-09-13",
    description: "Discover the latest in Chinese-language writing on science and technology.",
    homepage: true,
  },
  {
    name: "Supply Chain Explorer",
    tags: ["supply chain", "semiconductors"],
    url: "https://chipexplorer.eto.tech",
    documentationUrl: "/tool-docs/chipexplorer",
    lastUpdated: "2022-09-07",
    description: "A guide to the vast, complex, and critical supply chain for advanced computer chips.",
    homepage: true,
  },
];
